import React, { useEffect, useState } from "react";
import {
  AppBar,
  Dialog,
  IconButton,
  Toolbar,
  Typography,
  Button,
  CircularProgress,
  Grid2,
  ToggleButton,
} from "@mui/material";
import CloseIcon from "@mui/icons-material/Close";
import { useApi } from "../../utils/api";
import Exercise from "./Exercise";
import { Field, Form } from "react-final-form";
import arrayMutators from "final-form-arrays";
import { useLocation, useNavigate, useParams } from "react-router-dom";
import Loading from "../Layout/Loading";
import Snackbar from "@mui/material/Snackbar";
import { normalizeWeightForPayload } from "../../utils/weightPayload";

const LogWorkout = () => {
  const { saveWorkoutDetails, getWorkout } = useApi();
  const [workout, setWorkout] = useState(null);
  const params = useParams();
  const navigate = useNavigate();
  const location = useLocation();

  useEffect(() => {
    const get = async () => {
      const response = await getWorkout(params.workoutId);
      setWorkout(response);
    };

    get();
  }, [params?.workoutId]);

  const onSave = async (v) => {
    const values = {
      reviewed: workout.reviewed ? true : false,
      completed: v.completed,
      exercises: v.exercises.map((exercise) => ({
        ...exercise,
        sets: exercise.sets.map((set) => {
          const formattedSet = {
            ...set,
          };
          if (set.weight !== undefined && set.weight !== null && set.weight !== "") {
            formattedSet.weight = normalizeWeightForPayload(set.weight);
          }
          return formattedSet;
        }),
      })),
    };
    await saveWorkoutDetails(workout.id, values);
  };

  const handleClose = () => {
    navigate(location.state.prevPath);
  };

  if (!workout) {
    return <Loading style={{ mt: 4 }} />;
  }

  return (
    <Dialog fullScreen open onClose={handleClose}>
      <Form
        onSubmit={onSave}
        mutators={{
          ...arrayMutators,
        }}
        initialValues={{
          exercises: workout.exercises,
          completed: workout.completed,
        }}
        render={({ handleSubmit, pristine }) => (
          <>
            <AppBar sx={{ position: "relative" }}>
              <Toolbar>
                <IconButton
                  edge="start"
                  color="inherit"
                  onClick={handleClose}
                  aria-label="close"
                >
                  <CloseIcon />
                </IconButton>
                <Typography
                  sx={{ mr: 2, flex: 1, textAlign: "center" }}
                  variant="h6"
                  component="div"
                >
                  {workout.name}
                </Typography>
              </Toolbar>
            </AppBar>
            <Grid2 display="flex" justifyContent="center">
              <Grid2 lg={6} sm={10}>
                {workout.exercises ? (
                  workout.exercises.map((exercise, i) => (
                    <Exercise
                      exercise={exercise}
                      index={i}
                      currentWorkoutDate={workout.date}
                    />
                  ))
                ) : (
                  <CircularProgress />
                )}
                <Grid2 sx={{ m: 2 }}>
                  <Field
                    name="completed"
                    render={({ input }) => (
                      <ToggleButton
                        size="small"
                        value="check"
                        fullWidth
                        sx={{
                          backgroundColor: "red !important",
                        }}
                        selected={input.value}
                        onChange={() => {
                          const newValue = !input.value;
                          input.onChange(newValue);
                          if (newValue) {
                            handleSubmit();
                          }
                        }}
                      >
                        <Typography sx={{ color: "white" }}>
                          {input.value ? "Completed" : "Mark Complete"}
                        </Typography>
                      </ToggleButton>
                    )}
                  />
                </Grid2>
              </Grid2>
            </Grid2>
          </>
        )}
      />
    </Dialog>
  );
};

export default LogWorkout;
